export const WHATSAPP_NUMBER = "18295067111";

export const waLink = (message, number = WHATSAPP_NUMBER) =>
  `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MSG =
  "Hola Landerlan Dominicana, quisiera realizar una consulta / pedido sobre su catálogo de productos en República Dominicana.";

const B = "https://landerpharma.com.py/rails/active_storage/blobs/redirect/";

export const LINES = {
  landerlan: {
    name: "Línea Landerlan",
    color: "#B8912F",
    badgeBg: "rgba(184,145,47,0.12)",
    badgeBorder: "rgba(184,145,47,0.45)",
    desc: "Cuidado integral del día a día con formulaciones confiables y eficacia comprobada.",
    banner: B + "eyJfcmFpbHMiOnsiZGF0YSI6ODA3NCwicHVyIjoiYmxvYl9pZCJ9fQ==--4aed0fff019601a08519bedcc5dd5bc872703d79/LANDER.png",
  },
  silver: {
    name: "Silver Series",
    color: "#8A939E",
    badgeBg: "rgba(138,147,158,0.12)",
    badgeBorder: "rgba(138,147,158,0.45)",
    desc: "Rendimiento constante y bienestar sostenido con precisión farmacéutica y excelente tolerabilidad.",
    banner: B + "eyJfcmFpbHMiOnsiZGF0YSI6ODM5MCwicHVyIjoiYmxvYl9pZCJ9fQ==--2901c9d1197ee2bb4158d0ab7011c890f52e3673/LANDER%20SILVER.png",
  },
  gold: {
    name: "Gold Series",
    color: "#D4A017",
    badgeBg: "rgba(212,160,23,0.12)",
    badgeBorder: "rgba(212,160,23,0.45)",
    desc: "Alto rendimiento, vitalidad y bienestar integral con alta pureza y biodisponibilidad.",
    banner: B + "eyJfcmFpbHMiOnsiZGF0YSI6ODA3NiwicHVyIjoiYmxvYl9pZCJ9fQ==--8171d6db53042e10be6c72a212109a9b735eedbb/LANDER%20GOLD.png",
  },
  diamond: {
    name: "Diamond Series",
    color: "#0284C7",
    badgeBg: "rgba(2,132,199,0.10)",
    badgeBorder: "rgba(2,132,199,0.40)",
    desc: "El máximo nivel de excelencia: pureza, tecnología y rigor farmacéutico premium.",
    banner: B + "eyJfcmFpbHMiOnsiZGF0YSI6ODM5MiwicHVyIjoiYmxvYl9pZCJ9fQ==--61c23fda4dae38de2eeda977965eaffda4bb67f0/LANDER%20DIAMOND.png",
  },
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
